import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, $state, NavigationService) => {
    const ctrl = Object.create(BaseCtrl);

    /* This is basically the same code as the NavigationDirective, but that is not used on all pages. In cases where we want to cancel an action
     rather than return, this function is used. */
    ctrl.goToPrevious = () => {
        const navHistoryObj = NavigationService.recentHistory();
        const previous = (navHistoryObj) ? navHistoryObj.from : null;
        if (previous) {
            if (previous.params) {
                $state.transitionTo(previous.state.name, previous.params);
            } else {
                $state.transitionTo(previous.state.name);
            }
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', 'NavigationService'];

export default fn;
